// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IBeneficiaryAddressDto } from './IBeneficiaryAddressDto';
import {
    IBeneficiaryAddressDtoFromJSON,
    IBeneficiaryAddressDtoFromJSONTyped,
    IBeneficiaryAddressDtoToJSON,
    IBeneficiaryAddressDtoToJSONTyped,
} from './IBeneficiaryAddressDto';

/**
 * 
 * @export
 * @interface IBeneficiaryDto
 */
export interface IBeneficiaryDto {
    /**
     * 
     * @type {number}
     * @memberof IBeneficiaryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryDto
     */
    beneficiary_type?: IBeneficiaryDtoBeneficiaryTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IBeneficiaryDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryDto
     */
    tax_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IBeneficiaryDto
     */
    relationship_type?: IBeneficiaryDtoRelationshipTypeEnum;
    /**
     * 
     * @type {IBeneficiaryAddressDto}
     * @memberof IBeneficiaryDto
     */
    address?: IBeneficiaryAddressDto;
    /**
     * 
     * @type {number}
     * @memberof IBeneficiaryDto
     */
    allocation_percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof IBeneficiaryDto
     */
    employee_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IBeneficiaryDtoBeneficiaryTypeEnum {
    PRIMARY = 'PRIMARY',
    CONTINGENT = 'CONTINGENT'
}
/**
* @export
* @enum {string}
*/
export enum IBeneficiaryDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    PARTNER = 'PARTNER',
    CHILD = 'CHILD',
    PARENT = 'PARENT',
    DEPENDENT = 'DEPENDENT',
    GUARDIAN = 'GUARDIAN',
    TRUST = 'TRUST',
    ESTATE = 'ESTATE',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the IBeneficiaryDto interface.
 */
export function instanceOfIBeneficiaryDto(value: object): value is IBeneficiaryDto {
    return true;
}

export function IBeneficiaryDtoFromJSON(json: any): IBeneficiaryDto {
    return IBeneficiaryDtoFromJSONTyped(json, false);
}

export function IBeneficiaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBeneficiaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'beneficiary_type': json['beneficiary_type'] == null ? undefined : json['beneficiary_type'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'tax_id': json['tax_id'] == null ? undefined : json['tax_id'],
        'relationship_type': json['relationship_type'] == null ? undefined : json['relationship_type'],
        'address': json['address'] == null ? undefined : IBeneficiaryAddressDtoFromJSON(json['address']),
        'allocation_percentage': json['allocation_percentage'] == null ? undefined : json['allocation_percentage'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
    };
}

export function IBeneficiaryDtoToJSON(json: any): IBeneficiaryDto {
    return IBeneficiaryDtoToJSONTyped(json, false);
}

export function IBeneficiaryDtoToJSONTyped(value?: IBeneficiaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'beneficiary_type': value['beneficiary_type'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'ssn': value['ssn'],
        'tax_id': value['tax_id'],
        'relationship_type': value['relationship_type'],
        'address': IBeneficiaryAddressDtoToJSON(value['address']),
        'allocation_percentage': value['allocation_percentage'],
        'employee_id': value['employee_id'],
    };
}

